/** ISO codes → display symbol (unknown codes fall back to the code itself). */
export const CURRENCY_SYMBOLS = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  JPY: '¥',
  CNY: '¥',
  CHF: 'Fr',
  CAD: 'CA$',
  AUD: 'A$',
  NZD: 'NZ$',
  HKD: 'HK$',
  SGD: 'S$',
  SEK: 'kr',
  NOK: 'kr',
  DKK: 'kr',
  PLN: 'zł',
  CZK: 'Kč',
  HUF: 'Ft',
  RON: 'lei',
  BGN: 'лв',
  HRK: 'kn',
  RUB: '₽',
  TRY: '₺',
  UAH: '₴',
  KZT: '₸',
  AMD: '֏',
  GEL: '₾',
  AZN: '₼',
  BRL: 'R$',
  MXN: 'MX$',
  ARS: 'AR$',
  CLP: 'CL$',
  COP: 'CO$',
  PEN: 'S/',
  INR: '₹',
  IDR: 'Rp',
  MYR: 'RM',
  THB: '฿',
  VND: '₫',
  PHP: '₱',
  KRW: '₩',
  ILS: '₪',
  SAR: '﷼',
  AED: 'د.إ',
  ZAR: 'R',
  BTC: '₿',
  mBTC: 'm₿',
  uBTC: 'μ₿',
  ETH: 'Ξ',
  mETH: 'mΞ',
  LTC: 'Ł',
  XRP: 'XRP',
  USDT: '₮',
  USDC: 'USDC',
  BNB: 'BNB',
  SOL: '◎',
  ADA: '₳',
  DOT: 'DOT',
  MATIC: 'MATIC',
  DOGE: 'Ð',
  TRX: 'TRX',
  TON: 'TON',
  FUN: 'FUN',
  COIN: 'COIN',
};

/** Prefer ISO code over ambiguous glyph. */
export const CURRENCY_USE_CODE = new Set([
  'XRP',
  'BNB',
  'USDC',
  'DOT',
  'MATIC',
  'TRX',
  'TON',
  'FUN',
  'COIN',
]);

const PREFIX_SYMBOLS = new Set([
  '$',
  '€',
  '£',
  '¥',
  'Fr',
  'CA$',
  'A$',
  'NZ$',
  'HK$',
  'S$',
  '₿',
  'm₿',
  'μ₿',
  'Ξ',
  'mΞ',
  'Ł',
  '₮',
  '₳',
  'Ð',
  '◎',
  '₹',
  '₽',
  '₺',
  '₴',
  '₸',
  '֏',
  '₾',
  '₼',
  'R$',
  'MX$',
  '₪',
  '₱',
  '₩',
]);

const CRYPTO_CODES = new Set([
  'BTC',
  'mBTC',
  'uBTC',
  'ETH',
  'mETH',
  'LTC',
  'XRP',
  'USDT',
  'USDC',
  'BNB',
  'SOL',
  'ADA',
  'DOT',
  'MATIC',
  'DOGE',
  'TRX',
  'TON',
]);

export function getCurrencySymbol(code) {
  const c = String(code ?? '').trim();
  if (!c) return '';
  if (CURRENCY_USE_CODE.has(c)) return c;
  return CURRENCY_SYMBOLS[c] ?? c;
}

export function isPrefixCurrencySymbol(symbol) {
  return PREFIX_SYMBOLS.has(symbol);
}

export function isCryptoCurrencyCode(code) {
  return CRYPTO_CODES.has(String(code ?? '').trim());
}
